import ELEMENT_TOOLS from './toolDefinitions/toolbarElementToolConfig';
import { TOOLBAR_TOOLS } from './toolbarToolConfig';

const CREATE_ELEMENT_TOOLS_DEFAULT = [
    ELEMENT_TOOLS.ELEMENT_CARD,
    ELEMENT_TOOLS.ELEMENT_LINK,
    ELEMENT_TOOLS.ELEMENT_TASK_LIST,
    ELEMENT_TOOLS.ELEMENT_LINE,
    ELEMENT_TOOLS.ELEMENT_BOARD,
    ELEMENT_TOOLS.ELEMENT_COLUMN,
    ELEMENT_TOOLS.ELEMENT_COMMENT_THREAD,
    ELEMENT_TOOLS.ELEMENT_TABLE,
    ELEMENT_TOOLS.ELEMENT_SKETCH,
    ELEMENT_TOOLS.ELEMENT_COLOR_SWATCH,
    ELEMENT_TOOLS.ELEMENT_DOCUMENT,
    ELEMENT_TOOLS.ELEMENT_LINK_AUDIO,
    ELEMENT_TOOLS.ELEMENT_LINK_MAP,
    ELEMENT_TOOLS.ELEMENT_LINK_VIDEO,
    ELEMENT_TOOLS.ELEMENT_CARD_HEADING,
    TOOLBAR_TOOLS.META_MORE,
    TOOLBAR_TOOLS.META_DIVIDER,
    ELEMENT_TOOLS.TOOL_IMAGE,
    ELEMENT_TOOLS.TOOL_UPLOAD_FILE,
    ELEMENT_TOOLS.TOOL_ANNOTATE,
];

const CREATE_ELEMENT_TOOLS_WITH_AI_ASSISTANT = [...CREATE_ELEMENT_TOOLS_DEFAULT, ELEMENT_TOOLS.TOOL_AI_ASSISTANT];

const CREATE_ELEMENT_TOOLS_MOBILE = [
    ELEMENT_TOOLS.ELEMENT_CARD,
    ELEMENT_TOOLS.ELEMENT_LINK,
    ELEMENT_TOOLS.ELEMENT_TASK_LIST,
    ELEMENT_TOOLS.ELEMENT_BOARD,
    ELEMENT_TOOLS.ELEMENT_COLUMN,
    ELEMENT_TOOLS.ELEMENT_COMMENT_THREAD,
    ELEMENT_TOOLS.ELEMENT_LINE,
    ELEMENT_TOOLS.ELEMENT_COLOR_SWATCH,
    ELEMENT_TOOLS.ELEMENT_DOCUMENT,
    ELEMENT_TOOLS.ELEMENT_CARD_HEADING,
];

export const CREATE_ELEMENT_TOOLBARS = {
    DEFAULT: CREATE_ELEMENT_TOOLS_DEFAULT,
    MOBILE: CREATE_ELEMENT_TOOLS_MOBILE,
    WITH_AI_ASSISTANT: CREATE_ELEMENT_TOOLS_WITH_AI_ASSISTANT,
} as const;
